// Defining nuskin and nuskin.account namespace (if doesn't exist)
if ('undefined' === typeof window.nuskin){
    window.nuskin = {};
}

if ('undefined' === typeof window.nuskin.newShop) {
    window.nuskin.newShop = {};
}

window.nuskin.site = {};

export default window.nuskin;